/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-GroupSpacer{display:inline-block}"}]);
/* tslint:enable */